/** @format */

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // Import useLocation
import { UL } from "../../../AbstractElements";
import { RootState } from "../../../ReduxToolkit/Store";
import NotificationBox from "./NotificationBox";
// import MoonLight from "./MoonLight";
// import CartHeader from "./CartHeader";
import ProfileHeader from "./ProfileHeader";
import HoldCarts from "./HoldCarts";
import Syncing from "./Syncing";
import VendorSwitcherHeader from "./VendorSwitcher";
import ChatNav from "./Chat";
import { getVendorID } from "../../../services/helper";
import ProfileHeaderNonVendor from "./ProfileHeaderNonVendor";
import POSNav from "./POS";
import AudioTranslator from "./AudioTranslate";
import Settings from "./Settings";
import Transactions from "./Transactions";
import MyStore from "./MyStore";
import VideosNav from "./Videos";
// import MaximizeScreen from "./MaximizeScreen";
// import BookmarkHeader from "./BookmarkHeader";

const vendor_id = getVendorID();

export default function RightHeader() {
  const location = useLocation(); // Get current route
  const { isBackgroundWorking } = useSelector((state: RootState) => state.app);
  const { holdCarts, newOrders } = useSelector(
    (state: RootState) => state.cart
  );

  return (
    <UL className="nav-menus simple-list flex-row">
      {!vendor_id && <ProfileHeaderNonVendor />}

      {vendor_id && (
        <>
          {isBackgroundWorking && <Syncing />}
          {holdCarts.length > 0 && <HoldCarts holdCarts={holdCarts} />}
          {/* <VideosNav /> */}
          <POSNav />
          <ChatNav />
          <Transactions />
          <MyStore />
          {location.pathname === "/pos" && ( // ✅ Show only when path is /pos
            <>
              {/* <ShortCode /> */}
              {/* <Registers /> */}
              <NotificationBox />
              {/* <TaxToggle /> */}
              {/* <NoSale /> */}
              <AudioTranslator />
            </>
          )}
          <VendorSwitcherHeader />
          <Settings />
          <ProfileHeader />
        </>
      )}
    </UL>
  );
}
